// projectData.js
export const projects = {
  "clair-ai": {
    title: "ClairAI",
    subtitle: "Find, connect, and understand information across your company",
    category: "PRODUCT DESIGN - FULLSTACK WEB",
    image: "https://cdn.mupende.com/raw/QVL85k.webm",
    isVideo: true,
    disabled: true, // Set to true to disable this project
    description:
      "ClairAI is an intelligent company assistant that saves time by instantly finding, connecting, and summarizing scattered information across your organization — giving you clear answers when you need them.",
    challenge:
      "Employees in organizations of all sizes often struggle to find the information they need quickly and in a digestible format. Knowledge is scattered across tools, systems, and formats, making it difficult and time-consuming to locate relevant information.",
    solution:
      "I designed and developed an AI-powered search platform that connects data from multiple company systems, providing fast, contextual, and reliable information retrieval to save time and enhance productivity.",
    features: [
      {
        name: "Instant results.",
        description:
          "Delivers answers within seconds, enabling employees to find what they need without interrupting their workflow.",
        image: "https://cdn.mupende.com/raw/G4YvdH.mp4",
      },
      {
        name: "Contextual relevance.",
        description:
          "Understands user intent and summarizes scattered information into clear, relevant insights tailored to the query.",
        image: "https://cdn.mupende.com/raw/x9ILtl.png",
      },
      {
        name: "Transparent sources.",
        description:
          "Each answer is backed by direct references to original documents and data sources for full traceability and trust.",
        image: "https://cdn.mupende.com/raw/23X2no.png",
      },
      {
        name: "Proactive knowledge discovery.",
        description:
          "Suggests related information, documents, and insights users might not have searched for but that add valuable context.",
        image: "https://cdn.mupende.com/raw/THr24K.png",
      },
    ],
    technologies: [
      "React",
      "Node.js",
      "Python",
      "OpenAI API",
      "Vector Database",
      "TypeScript",
    ],
    results: [
      "90% reduction in information search time",
      "75% increase in employee productivity",
      "Seamless integration with 15+ enterprise tools",
    ],
  },
  curapix: {
    title: "CuraPix",
    subtitle: "Keep the moments, lose the mess",
    category: "PRODUCT DESIGN - IOS/WEB DESIGN",
    image: "https://cdn.mupende.com/raw/w3Xs7f.png",
    isVideo: false,
    disabled: false, // Set to true to disable this project
    description:
      "CuraPix is a smart photo management platform that learns your personal sense of what matters. By understanding which photos hold meaning to you.",
    challenge:
      "Modern photo libraries are overflowing with clutter from screenshots and blurry images to meaningless duplicates. Traditional cleanup tools rely on generic rules and fail to understand what you actually consider valuable. This makes manual sorting time-consuming.",
    solution:
      "CuraPix uses personalized machine learning to understand what a user defines as a “meaningful photo.” It intelligently distinguishes between treasured memories and disposable content, automatically curating so your photo library stays clean, personal, and effortless to manage.",
    features: [
      {
        name: "Personalized Photo Curation.",
        description:
          "Uses machine learning to learn from your interactions and selections to recognize which photos you find meaningful and which you don’t.",
        image: "https://cdn.mupende.com/raw/gMc5VO.png",
      },
      {
        name: "Simple User Interface.",
        description:
          "An intuitive interface that makes organizing memories effortless.",
        image: "https://cdn.mupende.com/raw/TuFLlh.png",
      },
    ],
    technologies: ["React Native", "TensorFlow", "Python", "Sqlite"],
    results: [
      "95% accuracy in photo organization",
      "80% reduction in manual photo sorting time",
      "User satisfaction score of 4.8/5",
    ],
  },
  blutenblatt: {
    title: "Blütenblatt",
    subtitle: "Life journaling in newspaper style",
    category: "PERSONAL PROJECT – AI WRITING ASSISTANT",
    image: "https://cdn.mupende.com/raw/bdA0ak.png",
    isVideo: false,
    disabled: false, // Set to true to disable this project
    description:
      "Blütenblatt is a personal journaling system that transforms daily life events into beautifully formatted newspaper-style articles.",
    challenge:
      "Traditional journaling can feel mundane and people often struggle to maintain consistent writing habits or find engaging ways to document their lives.",
    solution:
      "I developed a unique journaling platform that uses AI to help users transform their daily experiences into engaging newspaper-style articles, making personal documentation both fun and meaningful. You can see a live example at https://www.inkidas.com/newsfront",
    features: [
      {
        name: "Newspaper-style formatting.",
        description:
          "Professional newspaper layout engine that automatically formats your entries with columns, headlines, bylines, and typography that matches classic newspaper design.",
        image: "https://cdn.mupende.com/raw/ZxQRgx.png",
      },
      {
        name: "AI-assisted article writing.",
        description:
          "Intelligent writing assistance that helps transform your daily experiences into engaging newspaper-style articles with proper structure, headlines, and compelling narratives.",
        image: "https://cdn.mupende.com/raw/wKhqNQ.png",
      },
    ],
    technologies: ["React", "Node.js", "Sqlite", "Python"],
    results: [
      "3x increase in journaling consistency",
      "Unique newspaper-style presentation",
      "Personal satisfaction in creative documentation",
    ],
  },
};

// Helper function to get only enabled projects
export const getEnabledProjects = () => {
  return Object.fromEntries(
    Object.entries(projects).filter(([key, project]) => !project.disabled)
  );
};

// Helper function to get enabled project keys
export const getEnabledProjectKeys = () => {
  return Object.keys(projects).filter((key) => !projects[key].disabled);
};

// Helper function to check if a project is enabled
export const isProjectEnabled = (projectId) => {
  return projects[projectId] && !projects[projectId].disabled;
};
